<template>

    <ActionCombo :noClearable="noClearable" :placeholder="placeholder" :skeleton="compSkeleton" :disabled="compDisabled" :rules="rules" v-model="dvalue" :items="items"
        :noContextMenu="noContextMenu"  open create route="masterdata.departments" baseType="department"
    >

    </ActionCombo>

</template>

<script setup>

    // import DepartmentCombo from '@controls/combo/Department'
    // <DepartmentCombo :model="model" :rules="model.rules.id_department" v-model="model.id_department"></DepartmentCombo>

    const props = defineProps({
        disabled: {
            type: [Boolean]
        },
        rules: {
            type: [Array]
        },
        noClearable: {
            type: [Boolean],
            default: false
        },
        skeleton: {
            type: [Boolean]
        },
        value: {
            type: [String, Number]
        },
        placeholder: {
            type: [String],
            default: 'Afdeling'
        },
        model: {
            type: [Object]
        },
        noContextMenu: {
            type: [Boolean],
            default: false
        },

    })
    
    import ActionCombo from '@controls/combo/ActionCombo'
    import {department as list} from '@app/list';
    import {computed} from 'vue'

    const emit = defineEmits(['input'])

    const dvalue = computed({
        get() {
            return props.value
        },
        set: function(v) {
            emit('input', v)
        }	
    })

    const compSkeleton = computed({
        get() {
            if (props.skeleton) {
                return true;
            }
            if (!props.model) {
                return false;
            }
            return props.model.isDataLoading;
        }
    });
    const compDisabled = computed({
        get() {
            if (props.disabled) {
                return true;
            }
            if (!props.model) {
                return false;
            }
            return props.model.disabled;
        }
    });

    const items = computed({
        get() {
            return list.listActual(dvalue.value) ||[]
        },
    })

</script>
